// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"04200522","924":"65fd301e"}[chunkId] + ".chunk.css";
};